// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parent profile panel — theme-aware (follows html[data-theme] / body.light-mode|dark-mode) */
.parent-profile-panel {
  --pp-text: var(--text-color, #0f172a);
  --pp-muted: var(--text-secondary, #64748b);
  --pp-surface: var(--bg-card, rgba(15, 23, 42, 0.04));
  --pp-surface-strong: rgba(15, 23, 42, 0.06);
  --pp-border: var(--profile-badge-border, rgba(15, 23, 42, 0.12));
  --pp-link: var(--brand-primary, #0877bc);
  --pp-accent: #c2410c;
  --pp-accent-bg: rgba(255, 164, 81, 0.16);
  --pp-accent-border: rgba(194, 65, 12, 0.35);
  --pp-input-bg: var(--profile-input-bg, #fff);
  --pp-input-border: var(--profile-input-border, rgba(15, 23, 42, 0.14));
  --pp-ok: #15803d;
  --pp-err: #b91c1c;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 0.75rem;
  text-align: left;
  color: var(--pp-text);
}

html[data-theme="dark"] .parent-profile-panel,
body.dark-mode .parent-profile-panel {
  --pp-text: var(--text-color, #f8fafc);
  --pp-muted: var(--text-secondary, #94a3b8);
  --pp-surface: rgba(148, 163, 184, 0.08);
  --pp-surface-strong: rgba(15, 23, 42, 0.45);
  --pp-border: rgba(148, 163, 184, 0.22);
  --pp-link: #7dd3fc;
  --pp-accent: #ffa451;
  --pp-accent-bg: rgba(255, 164, 81, 0.12);
  --pp-accent-border: rgba(255, 164, 81, 0.35);
  --pp-input-bg: rgba(15, 23, 42, 0.65);
  --pp-input-border: rgba(148, 163, 184, 0.35);
  --pp-ok: #86efac;
  --pp-err: #fca5a5;
}

.parent-profile-role-pill {
  align-self: center;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--pp-accent);
  background: var(--pp-accent-bg);
  border: 1px solid var(--pp-accent-border);
}

.parent-profile-scforh {
  margin-top: 0.25rem;
}

.parent-profile-scforh .ios-objectives-header h3 {
  color: var(--pp-muted);
}

.parent-profile-scforh-note {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: var(--pp-muted);
}

.parent-profile-scforh-expand {
  margin-top: 0.85rem;
  border-radius: 12px;
  border: 1px solid var(--pp-border);
  background: var(--pp-surface);
  overflow: hidden;
}

.parent-profile-scforh-expand > summary {
  list-style: none;
  cursor: pointer;
  padding: 0.7rem 0.9rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--pp-text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.parent-profile-scforh-expand > summary::-webkit-details-marker {
  display: none;
}

.parent-profile-scforh-expand > summary::after {
  content: "▸";
  color: var(--pp-muted);
  font-size: 0.75rem;
  transition: transform 0.15s ease;
}

.parent-profile-scforh-expand[open] > summary::after {
  transform: rotate(90deg);
}

.parent-profile-scforh-expand .who-capsule {
  padding: 0 0.75rem 0.85rem;
}

.parent-profile-scforh-expand .who-capsule__eyebrow {
  display: none;
}

.parent-profile-children {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem 1.1rem;
  border-radius: 16px;
  background: var(--pp-surface);
  border: 1px solid var(--pp-border);
}

.parent-profile-children-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.parent-profile-children-header h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--pp-text);
}

.parent-profile-link-btn,
.parent-profile-primary-btn,
.parent-profile-secondary-btn {
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.82rem;
  border-radius: 10px;
  padding: 0.55rem 0.9rem;
}

.parent-profile-link-btn {
  background: transparent;
  color: var(--pp-link);
  text-decoration: underline;
  padding: 0.25rem 0.4rem;
}

.parent-profile-primary-btn {
  background: linear-gradient(135deg, #ffa451, #f97316);
  color: #0f172a;
}

.parent-profile-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.parent-profile-fltt {
  display: grid;
  gap: 8px;
  margin: 4px 0 12px;
}

.parent-profile-secondary-btn {
  align-self: flex-start;
  background: var(--pp-surface-strong);
  color: var(--pp-text);
  border: 1px solid var(--pp-border);
}

.parent-profile-muted,
.parent-profile-empty p {
  margin: 0;
  color: var(--pp-muted);
  font-size: 0.88rem;
  line-height: 1.4;
}

.parent-profile-child-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.parent-profile-child-card {
  padding: 0.85rem 0.95rem;
  border-radius: 14px;
  background: var(--pp-surface-strong);
  border: 1px solid var(--pp-border);
}

.parent-profile-child-top {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.parent-profile-child-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--pp-surface);
  border: 1px solid var(--pp-border);
}

button.parent-profile-child-avatar--photo {
  padding: 0;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

button.parent-profile-child-avatar--photo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.parent-profile-child-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.parent-profile-photo-btn {
  margin-top: 0.35rem;
  border: none;
  background: transparent;
  padding: 0;
  color: var(--pp-link);
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

.parent-profile-photo-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.parent-profile-consent {
  margin-top: 0.85rem;
  padding: 0.85rem 0.9rem;
  border-radius: 14px;
  border: 1px solid var(--pp-accent-border);
  background: var(--pp-accent-bg);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.parent-profile-consent-head {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.parent-profile-consent-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--pp-text);
}

.parent-profile-consent-kicker {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--pp-accent);
}

.parent-profile-consent-help {
  font-size: 0.78rem;
}

.parent-profile-consent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.65rem;
}

.parent-profile-consent-tile {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  padding: 0.7rem 0.75rem;
  border-radius: 12px;
  background: var(--pp-surface-strong);
  border: 1px solid var(--pp-border);
}

.parent-profile-consent-tile.is-granted {
  border-color: color-mix(in srgb, var(--pp-ok) 55%, transparent);
  background: color-mix(in srgb, var(--pp-ok) 12%, var(--pp-surface-strong));
}

.parent-profile-consent-tile.is-missing {
  border-color: var(--pp-accent-border);
  background: var(--pp-input-bg);
}

.parent-profile-consent-kind {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pp-muted);
}

.parent-profile-consent-state {
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.15;
  color: var(--pp-text);
}

.parent-profile-consent-tile.is-granted .parent-profile-consent-state {
  color: var(--pp-ok);
}

.parent-profile-consent-tile.is-missing .parent-profile-consent-state {
  color: var(--pp-accent);
}

.parent-profile-consent-detail {
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--pp-muted);
}

.parent-profile-consent-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.82rem;
  color: var(--pp-text);
}

.parent-profile-consent-btn {
  align-self: flex-start;
  margin-top: 0.25rem;
  flex-shrink: 0;
  border-radius: 999px;
  border: 1px solid var(--pp-border);
  background: var(--pp-surface);
  color: var(--pp-text);
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.35rem 0.75rem;
  cursor: pointer;
}

.parent-profile-consent-btn.is-on {
  background: transparent;
  border-color: color-mix(in srgb, var(--pp-ok) 45%, transparent);
  color: var(--pp-ok);
}

.parent-profile-consent-tile.is-missing .parent-profile-consent-btn {
  background: var(--pp-accent-bg);
  border-color: var(--pp-accent-border);
  color: var(--pp-accent);
}

.parent-profile-consent-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.parent-profile-medical {
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--pp-border);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.parent-profile-medical .parent-profile-consent-title {
  font-size: 0.82rem;
  font-weight: 700;
}

.parent-profile-medical-input {
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 4rem;
  border-radius: 10px;
  border: 1px solid var(--pp-input-border);
  background: var(--pp-input-bg);
  color: var(--pp-text);
  padding: 0.55rem 0.7rem;
  font-size: 0.85rem;
  line-height: 1.4;
  font-family: inherit;
}

.parent-profile-child-top strong {
  color: var(--pp-text);
  font-size: 0.95rem;
}

.parent-profile-child-top p {
  margin: 0.15rem 0 0;
  font-size: 0.8rem;
  color: var(--pp-muted);
}

.parent-profile-open-account {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--pp-border);
}

.parent-profile-open-account > p {
  margin: 0 0 0.65rem;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--pp-muted);
}

.parent-profile-open-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.parent-profile-open-row input {
  flex: 1 1 160px;
  min-width: 0;
  border-radius: 10px;
  border: 1px solid var(--pp-input-border);
  background: var(--pp-input-bg);
  color: var(--pp-text);
  padding: 0.55rem 0.75rem;
  font-size: 0.85rem;
}

.parent-profile-open-row input::placeholder {
  color: var(--pp-muted);
  opacity: 0.85;
}

.parent-profile-feedback {
  margin: 0.25rem 0 0;
  font-size: 0.85rem;
  line-height: 1.4;
}

.parent-profile-feedback--ok {
  color: var(--pp-ok);
}

.parent-profile-feedback--error {
  color: var(--pp-err);
}

@media (max-width: 640px) {
  .parent-profile-consent-grid {
    grid-template-columns: 1fr;
  }

  .parent-profile-open-row {
    flex-direction: column;
  }

  .parent-profile-open-row .parent-profile-primary-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ParentProfilePanel.css"],"names":[],"mappings":"AAAA,8FAA8F;AAC9F;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oDAAoD;EACpD,2CAA2C;EAC3C,gEAAgE;EAChE,wCAAwC;EACxC,oBAAoB;EACpB,wCAAwC;EACxC,2CAA2C;EAC3C,4CAA4C;EAC5C,sEAAsE;EACtE,gBAAgB;EAChB,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,2CAA2C;EAC3C,sCAAsC;EACtC,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;EACxC,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,+DAA+D;EAC/D,0EAA0E;AAC5E;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Parent profile panel — theme-aware (follows html[data-theme] / body.light-mode|dark-mode) */\n.parent-profile-panel {\n  --pp-text: var(--text-color, #0f172a);\n  --pp-muted: var(--text-secondary, #64748b);\n  --pp-surface: var(--bg-card, rgba(15, 23, 42, 0.04));\n  --pp-surface-strong: rgba(15, 23, 42, 0.06);\n  --pp-border: var(--profile-badge-border, rgba(15, 23, 42, 0.12));\n  --pp-link: var(--brand-primary, #0877bc);\n  --pp-accent: #c2410c;\n  --pp-accent-bg: rgba(255, 164, 81, 0.16);\n  --pp-accent-border: rgba(194, 65, 12, 0.35);\n  --pp-input-bg: var(--profile-input-bg, #fff);\n  --pp-input-border: var(--profile-input-border, rgba(15, 23, 42, 0.14));\n  --pp-ok: #15803d;\n  --pp-err: #b91c1c;\n\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  margin-top: 0.75rem;\n  text-align: left;\n  color: var(--pp-text);\n}\n\nhtml[data-theme=\"dark\"] .parent-profile-panel,\nbody.dark-mode .parent-profile-panel {\n  --pp-text: var(--text-color, #f8fafc);\n  --pp-muted: var(--text-secondary, #94a3b8);\n  --pp-surface: rgba(148, 163, 184, 0.08);\n  --pp-surface-strong: rgba(15, 23, 42, 0.45);\n  --pp-border: rgba(148, 163, 184, 0.22);\n  --pp-link: #7dd3fc;\n  --pp-accent: #ffa451;\n  --pp-accent-bg: rgba(255, 164, 81, 0.12);\n  --pp-accent-border: rgba(255, 164, 81, 0.35);\n  --pp-input-bg: rgba(15, 23, 42, 0.65);\n  --pp-input-border: rgba(148, 163, 184, 0.35);\n  --pp-ok: #86efac;\n  --pp-err: #fca5a5;\n}\n\n.parent-profile-role-pill {\n  align-self: center;\n  padding: 0.35rem 0.85rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--pp-accent);\n  background: var(--pp-accent-bg);\n  border: 1px solid var(--pp-accent-border);\n}\n\n.parent-profile-scforh {\n  margin-top: 0.25rem;\n}\n\n.parent-profile-scforh .ios-objectives-header h3 {\n  color: var(--pp-muted);\n}\n\n.parent-profile-scforh-note {\n  margin: 0.75rem 0 0;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: var(--pp-muted);\n}\n\n.parent-profile-scforh-expand {\n  margin-top: 0.85rem;\n  border-radius: 12px;\n  border: 1px solid var(--pp-border);\n  background: var(--pp-surface);\n  overflow: hidden;\n}\n\n.parent-profile-scforh-expand > summary {\n  list-style: none;\n  cursor: pointer;\n  padding: 0.7rem 0.9rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--pp-text);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.parent-profile-scforh-expand > summary::-webkit-details-marker {\n  display: none;\n}\n\n.parent-profile-scforh-expand > summary::after {\n  content: \"▸\";\n  color: var(--pp-muted);\n  font-size: 0.75rem;\n  transition: transform 0.15s ease;\n}\n\n.parent-profile-scforh-expand[open] > summary::after {\n  transform: rotate(90deg);\n}\n\n.parent-profile-scforh-expand .who-capsule {\n  padding: 0 0.75rem 0.85rem;\n}\n\n.parent-profile-scforh-expand .who-capsule__eyebrow {\n  display: none;\n}\n\n.parent-profile-children {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  padding: 1rem 1.1rem;\n  border-radius: 16px;\n  background: var(--pp-surface);\n  border: 1px solid var(--pp-border);\n}\n\n.parent-profile-children-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.parent-profile-children-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--pp-text);\n}\n\n.parent-profile-link-btn,\n.parent-profile-primary-btn,\n.parent-profile-secondary-btn {\n  border: none;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.82rem;\n  border-radius: 10px;\n  padding: 0.55rem 0.9rem;\n}\n\n.parent-profile-link-btn {\n  background: transparent;\n  color: var(--pp-link);\n  text-decoration: underline;\n  padding: 0.25rem 0.4rem;\n}\n\n.parent-profile-primary-btn {\n  background: linear-gradient(135deg, #ffa451, #f97316);\n  color: #0f172a;\n}\n\n.parent-profile-primary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.parent-profile-fltt {\n  display: grid;\n  gap: 8px;\n  margin: 4px 0 12px;\n}\n\n.parent-profile-secondary-btn {\n  align-self: flex-start;\n  background: var(--pp-surface-strong);\n  color: var(--pp-text);\n  border: 1px solid var(--pp-border);\n}\n\n.parent-profile-muted,\n.parent-profile-empty p {\n  margin: 0;\n  color: var(--pp-muted);\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.parent-profile-child-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.parent-profile-child-card {\n  padding: 0.85rem 0.95rem;\n  border-radius: 14px;\n  background: var(--pp-surface-strong);\n  border: 1px solid var(--pp-border);\n}\n\n.parent-profile-child-top {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.parent-profile-child-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--pp-surface);\n  border: 1px solid var(--pp-border);\n}\n\nbutton.parent-profile-child-avatar--photo {\n  padding: 0;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n}\n\nbutton.parent-profile-child-avatar--photo:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.parent-profile-child-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.parent-profile-photo-btn {\n  margin-top: 0.35rem;\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: var(--pp-link);\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n\n.parent-profile-photo-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.parent-profile-consent {\n  margin-top: 0.85rem;\n  padding: 0.85rem 0.9rem;\n  border-radius: 14px;\n  border: 1px solid var(--pp-accent-border);\n  background: var(--pp-accent-bg);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.parent-profile-consent-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.parent-profile-consent-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--pp-text);\n}\n\n.parent-profile-consent-kicker {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--pp-accent);\n}\n\n.parent-profile-consent-help {\n  font-size: 0.78rem;\n}\n\n.parent-profile-consent-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.65rem;\n}\n\n.parent-profile-consent-tile {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  padding: 0.7rem 0.75rem;\n  border-radius: 12px;\n  background: var(--pp-surface-strong);\n  border: 1px solid var(--pp-border);\n}\n\n.parent-profile-consent-tile.is-granted {\n  border-color: color-mix(in srgb, var(--pp-ok) 55%, transparent);\n  background: color-mix(in srgb, var(--pp-ok) 12%, var(--pp-surface-strong));\n}\n\n.parent-profile-consent-tile.is-missing {\n  border-color: var(--pp-accent-border);\n  background: var(--pp-input-bg);\n}\n\n.parent-profile-consent-kind {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--pp-muted);\n}\n\n.parent-profile-consent-state {\n  font-size: 1.05rem;\n  font-weight: 800;\n  line-height: 1.15;\n  color: var(--pp-text);\n}\n\n.parent-profile-consent-tile.is-granted .parent-profile-consent-state {\n  color: var(--pp-ok);\n}\n\n.parent-profile-consent-tile.is-missing .parent-profile-consent-state {\n  color: var(--pp-accent);\n}\n\n.parent-profile-consent-detail {\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: var(--pp-muted);\n}\n\n.parent-profile-consent-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.82rem;\n  color: var(--pp-text);\n}\n\n.parent-profile-consent-btn {\n  align-self: flex-start;\n  margin-top: 0.25rem;\n  flex-shrink: 0;\n  border-radius: 999px;\n  border: 1px solid var(--pp-border);\n  background: var(--pp-surface);\n  color: var(--pp-text);\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.35rem 0.75rem;\n  cursor: pointer;\n}\n\n.parent-profile-consent-btn.is-on {\n  background: transparent;\n  border-color: color-mix(in srgb, var(--pp-ok) 45%, transparent);\n  color: var(--pp-ok);\n}\n\n.parent-profile-consent-tile.is-missing .parent-profile-consent-btn {\n  background: var(--pp-accent-bg);\n  border-color: var(--pp-accent-border);\n  color: var(--pp-accent);\n}\n\n.parent-profile-consent-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.parent-profile-medical {\n  margin-top: 0.85rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--pp-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.parent-profile-medical .parent-profile-consent-title {\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.parent-profile-medical-input {\n  width: 100%;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 4rem;\n  border-radius: 10px;\n  border: 1px solid var(--pp-input-border);\n  background: var(--pp-input-bg);\n  color: var(--pp-text);\n  padding: 0.55rem 0.7rem;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  font-family: inherit;\n}\n\n.parent-profile-child-top strong {\n  color: var(--pp-text);\n  font-size: 0.95rem;\n}\n\n.parent-profile-child-top p {\n  margin: 0.15rem 0 0;\n  font-size: 0.8rem;\n  color: var(--pp-muted);\n}\n\n.parent-profile-open-account {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--pp-border);\n}\n\n.parent-profile-open-account > p {\n  margin: 0 0 0.65rem;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: var(--pp-muted);\n}\n\n.parent-profile-open-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.parent-profile-open-row input {\n  flex: 1 1 160px;\n  min-width: 0;\n  border-radius: 10px;\n  border: 1px solid var(--pp-input-border);\n  background: var(--pp-input-bg);\n  color: var(--pp-text);\n  padding: 0.55rem 0.75rem;\n  font-size: 0.85rem;\n}\n\n.parent-profile-open-row input::placeholder {\n  color: var(--pp-muted);\n  opacity: 0.85;\n}\n\n.parent-profile-feedback {\n  margin: 0.25rem 0 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.parent-profile-feedback--ok {\n  color: var(--pp-ok);\n}\n\n.parent-profile-feedback--error {\n  color: var(--pp-err);\n}\n\n@media (max-width: 640px) {\n  .parent-profile-consent-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .parent-profile-open-row {\n    flex-direction: column;\n  }\n\n  .parent-profile-open-row .parent-profile-primary-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
